<template>
  <div class="container mt-lg-5 position-relative">
    <h2>{{ $t('personas') }}</h2>
    <div class="d-flex flex-wrap justify-content-start align-items-center overflow-hidden gap-3 fondo-terciario rounded-3 px-2 sombra-sm">
      <button
          class="btn-menu-2 fs-6 d-inline-flex gap-2 py-2 texto-secundario"
          :class="{'active-btn': MenuVisible == 1}"
          @click="MenuVisible = 1"
      >
          {{ $t('datosPersonales') }}
      </button>
      <button v-if="hasManejarRolesPermission"
          class="btn-menu-2 fs-6 d-inline-flex gap-2 py-2 texto-secundario"
          :class="{'active-btn': MenuVisible == 2}"
          @click="MenuVisible = 2"
      >
          <span>{{ $t('roles') }}</span>
      </button>
      <button v-if="hasManejarPermisosPermission"
          class="btn-menu-2 fs-6 d-inline-flex gap-2 py-2 texto-secundario"
          :class="{'active-btn': MenuVisible == 3}"
          @click="MenuVisible = 3"
      >
          <span>{{ $t('permisos') }}</span>
      </button>
      <button v-if="hasEditarListasPermission"
          class="btn-menu-2 fs-6 d-inline-flex gap-2 py-2 texto-secundario"
          :class="{'active-btn': MenuVisible == 4}"
          @click="MenuVisible = 4"
      >
          {{ $t('gruposYListas') }}
      </button>
      <button v-if="hasManejarHorariosPermission || hasManejarAusenciasSuplenciasPermission || hasManejarDatosFaltantesPermission"
          class="btn-menu-2 fs-6 d-inline-flex gap-2 py-2 texto-secundario"
          :class="{'active-btn': MenuVisible == 5}"
          @click="MenuVisible = 5"
      >
          {{ $t('rrhh') }}
      </button>
      <div v-if="loadingMenu" class="loading-spinner h-100 d-inline-flex align-items-center justify-content-center">
          <img src="@/assets/LOADING.gif" style="width: 20px;" alt="Cargando..." />
      </div>
    </div>

    <div v-if="MenuVisible == 1" class="d-flex flex-column gap-2">
        <VerPersonas/>
    </div>

    <div v-if="MenuVisible == 2" class="d-flex flex-column gap-2">
        <VerRoles/>
    </div>

    <div v-if="MenuVisible == 3" class="d-flex flex-column gap-2">
        <VerPermisos/>
    </div>

    <div v-if="MenuVisible == 4" class="d-flex flex-column gap-2">
        <VerGrupos/>
    </div>

    <div v-if="MenuVisible == 5" class="d-flex flex-column gap-2">
        <RrhhPage/>
    </div>

  </div>
</template>

<script>
  import { ref, onMounted, computed, watch } from 'vue';
  import {useStore} from "vuex";
  import {useRouter} from "vue-router";
  import { useI18n } from 'vue-i18n';
  import VerPersonas from './VerPersonas.vue';
  import VerRoles from './VerRoles.vue';
  import VerGrupos from './VerGrupos.vue';
  import RrhhPage from './RRHH/RrhhPage.vue';
import VerPermisos from './VerPermisos.vue';

export default {
  name: 'PersonasPage',
   components: {
     VerPersonas,
     VerRoles,
     VerGrupos,
     RrhhPage,
     VerPermisos
   },
  setup() {
    const { t } = useI18n();
    const router = useRouter();
    const store = useStore();
    const user = computed(() => store.state.user);
    const MenuVisible = ref(1);
    var hasVerPersonasPermission = ref(false);
    var hasManejarRolesPermission = ref(false);
    var hasManejarPermisosPermission = ref(false);
    var hasEditarListasPermission = ref(false);
    var hasManejarHorariosPermission = ref(false);
    var hasManejarAusenciasSuplenciasPermission = ref(false);
    var hasManejarDatosFaltantesPermission = ref(false);


    const checkAuth = async  () => {
      if (user.value && user.value.personasPermisos) {
        var permisoAComprobar = 'VerPersonas'
        if (user.value.personasPermisos?.some(persPermiso => persPermiso.idPermisoNavigation?.subCategoria === permisoAComprobar) || 
          user.value.personasRoles?.some(persRoles => persRoles.idRolNavigation?.permisos?.some(p => p.subCategoria === permisoAComprobar))){
          hasVerPersonasPermission.value = true;
        }
        
        permisoAComprobar = 'ManejarRoles'
        if (user.value.personasPermisos.some(persPermiso => persPermiso.idPermisoNavigation?.permiso === permisoAComprobar) || 
          user.value.personasRoles.some(persRoles => persRoles.idRolNavigation?.permisos?.some(p => p.permiso === permisoAComprobar))){
          hasManejarRolesPermission.value = true;
        }
        
        permisoAComprobar = 'ManejarPermisos'
        if (user.value.personasPermisos.some(persPermiso => persPermiso.idPermisoNavigation?.permiso === permisoAComprobar) || 
          user.value.personasRoles.some(persRoles => persRoles.idRolNavigation?.permisos?.some(p => p.permiso === permisoAComprobar))){
          hasManejarPermisosPermission.value = true;
        }

        permisoAComprobar = 'EditarListas'
        if (user.value.personasPermisos?.some(persPermiso => persPermiso.idPermisoNavigation?.permiso === permisoAComprobar) || 
          user.value.personasRoles?.some(persRoles => persRoles.idRolNavigation?.permisos?.some(p => p.permiso === permisoAComprobar)))
        {
          hasEditarListasPermission.value = true;
        }

        permisoAComprobar = 'ManejarHorarios'
        if (user.value.personasPermisos?.some(persPermiso => persPermiso.idPermisoNavigation?.permiso === permisoAComprobar) || 
            user.value.personasRoles?.some(persRoles => persRoles.idRolNavigation?.permisos?.some(p => p.permiso === permisoAComprobar)))
        {
            hasManejarHorariosPermission.value = true;
        }

        permisoAComprobar = 'ManejarAusenciasSuplencias'
        if (user.value.personasPermisos?.some(persPermiso => persPermiso.idPermisoNavigation?.permiso === permisoAComprobar) || 
            user.value.personasRoles?.some(persRoles => persRoles.idRolNavigation?.permisos?.some(p => p.permiso === permisoAComprobar)))
        {
            hasManejarAusenciasSuplenciasPermission.value = true;
        }

        permisoAComprobar = 'ManejarDatosFaltantes'
        if (user.value.personasPermisos?.some(persPermiso => persPermiso.idPermisoNavigation?.permiso === permisoAComprobar) || 
            user.value.personasRoles?.some(persRoles => persRoles.idRolNavigation?.permisos?.some(p => p.permiso === permisoAComprobar)))
        {
            hasManejarDatosFaltantesPermission.value = true;
        }

        if (hasVerPersonasPermission.value || hasManejarRolesPermission.value || hasManejarPermisosPermission.value || hasEditarListasPermission.value || hasManejarHorariosPermission.value || hasManejarAusenciasSuplenciasPermission.value || hasManejarDatosFaltantesPermission.value){
          console.log("Tiene Permiso")
        }
        else{
          console.log('Usuario no tiene permiso a acceder.');
          await router.push('/');
        }
      }
    };

    onMounted(() => {
      const lastUpdate = localStorage.getItem("lastUpdate");
      const today = new Date().toISOString().split("T")[0]; // Obtiene solo la fecha (YYYY-MM-DD)

      if (lastUpdate !== today) {
        localStorage.setItem("lastUpdate", today);
        window.location.reload(); // Recarga la página solo si no se ha recargado hoy
      }
      // Load saved menu preference
      const savedMenu = localStorage.getItem('personasPageMenuVisible');
      if (savedMenu) {
        MenuVisible.value = parseInt(savedMenu);
      }
      checkAuth();
    });

    // Watch for changes in MenuVisible and save to localStorage
    watch(MenuVisible, (newVal) => {
      localStorage.setItem('personasPageMenuVisible', newVal.toString());
    });

    return {
      checkAuth,
      t,
      MenuVisible,
      hasManejarRolesPermission,
      hasManejarPermisosPermission,
      hasEditarListasPermission,
      hasManejarHorariosPermission,
      hasManejarAusenciasSuplenciasPermission,
      hasManejarDatosFaltantesPermission,
    };
  },
};
</script>

<style>
.permissions-list {
  margin-top: 10px;
}

.roles-column {
  width: 250px; /* Fixed width for roles column */
}
</style>

